import React from "react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { useAdminShell } from "../contexts/adminShellContext";

const Header = () => {
  const { drawerOpen, toggleDrawer } = useAdminShell();

  const logoutHandler = async () => {
    try {
      await Cookies.remove("token");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <header className="main-header">
      <button
        type="button"
        className="btn btn-icon btn-mobile me-auto"
        onClick={toggleDrawer}
        aria-label={drawerOpen ? "Close menu" : "Open menu"}
        aria-expanded={drawerOpen}
        aria-controls="offcanvas_aside"
      >
        <i className="md-28 fas fa-bars" aria-hidden="true"></i>
      </button>

      <div className="header-image">
        <a href="/home">
          <img
            src="/images/fulllogo.png"
            alt="Tripoli Fresh Market"
            className="img-icon"
          />
        </a>
      </div>

      <div className="dropdown nav-item">
        <Link className="" data-bs-toggle="dropdown" to="#">
          <img src="/images/user.png" alt="User" width={30} height={30} />
          <span className=" custom-dropdown-arrow"></span>
        </Link>
        <div className="dropdown-menu dropdown-menu-end">
          <Link className="dropdown-item" to="/settings">
            Settings
          </Link>
          <Link
            onClick={logoutHandler}
            className="dropdown-item text-danger"
            to="/login"
          >
            Logout
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
